import React from "react";
import styles from "./canvas.module.css";

/** The fabric drawing surface; the board card sizes it (see Board/useCanvasFill). */
const Canvas = () => (
  <div className={styles.page}>
    <canvas id="canvas" width="800" height="500" />
  </div>
);

export default Canvas;
